import { createTheme } from '@mui/material/styles';

// Import themes from shared @barba/themes package
import {
  classic as classicTheme,
  premium as premiumTheme,
  vintage as vintageTheme,
  contemporary as contemporaryTheme,
  sunset as sunsetTheme
} from '@barba/themes';

const THEME_MAP = {
  classic: classicTheme,
  premium: premiumTheme,
  vintage: vintageTheme,
  contemporary: contemporaryTheme,
  sunset: sunsetTheme
};

/**
 * Create MUI theme from shop theme selection
 * @param {string} themeName - Theme identifier
 * @returns {Object} MUI theme object
 */
export function createAdminTheme(themeName = 'sunset') {
  const theme = THEME_MAP[themeName] || THEME_MAP.sunset;

  return createTheme({
    palette: {
      primary: {
        main: theme.colors.primary,
        light: theme.colors.primaryLight,
      },
      secondary: {
        main: theme.colors.accent,
        light: theme.colors.accentLight,
      },
      success: {
        main: theme.colors.success,
      },
      background: {
        default: theme.colors.background,
        paper: theme.colors.surface,
      },
    },
  });
}
